'use client';

import { RefreshCw, RotateCcw, WifiOff } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

type QueryErrorStateProps = {
  title: string;
  description: string;
  onRetry?: () => void;
  onReload?: () => void;
  retryLabel?: string;
  className?: string;
};

export default function QueryErrorState({
  title,
  description,
  onRetry,
  onReload,
  retryLabel = 'Try Again',
  className,
}: QueryErrorStateProps) {
  return (
    <Card className={className}>
      <CardHeader className="space-y-3">
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-border bg-secondary">
          <WifiOff className="h-5 w-5" />
        </div>
        <div>
          <CardTitle>{title}</CardTitle>
          <CardDescription className="mt-1">{description}</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
        {onRetry ? (
          <Button onClick={onRetry}>
            <RefreshCw className="h-4 w-4" />
            {retryLabel}
          </Button>
        ) : null}
        {onReload ? (
          <Button variant="outline" onClick={onReload}>
            <RotateCcw className="h-4 w-4" />
            Reload Page
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
}
